/**
 * @generated SignedSource<<a6274d91ac73e1a1f946ee4ded705fd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRootNodesTable_Refetch$variables = {
  after?: string | null | undefined;
  filterByInternalVnr?: string | null | undefined;
  filterByIsRewardedByAny?: boolean | null | undefined;
  filterByTagIds?: ReadonlyArray<string> | null | undefined;
  filterByTitleOrDescriptionOrShortDescription?: string | null | undefined;
  filterByVisibility?: boolean | null | undefined;
  filterByVnr?: string | null | undefined;
  first?: number | null | undefined;
};
export type ProjectRootNodesTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRootNodesTable_QueryFragment">;
};
export type ProjectRootNodesTable_Refetch = {
  response: ProjectRootNodesTable_Refetch$data;
  variables: ProjectRootNodesTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByInternalVnr"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByIsRewardedByAny"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTagIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTitleOrDescriptionOrShortDescription"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByVisibility"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByVnr"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filterByInternalVnr",
    "variableName": "filterByInternalVnr"
  },
  {
    "kind": "Variable",
    "name": "filterByIsRewardedByAny",
    "variableName": "filterByIsRewardedByAny"
  },
  {
    "kind": "Variable",
    "name": "filterByTagIds",
    "variableName": "filterByTagIds"
  },
  {
    "kind": "Variable",
    "name": "filterByTitleOrDescriptionOrShortDescription",
    "variableName": "filterByTitleOrDescriptionOrShortDescription"
  },
  {
    "kind": "Variable",
    "name": "filterByVisibility",
    "variableName": "filterByVisibility"
  },
  {
    "kind": "Variable",
    "name": "filterByVnr",
    "variableName": "filterByVnr"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitionType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dateTime",
    "storageKey": null
  }
],
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectRootNodesTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectRootNodesTable_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectRootNodesTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "TreeNodesConnection",
                "kind": "LinkedField",
                "name": "GetRootNodes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNodesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TreeNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "structureDefinition",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "extension",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TreeConfigConsequences",
                                            "kind": "LinkedField",
                                            "name": "configConsequences",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "rewardExpired",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRewardedTo",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "displayType",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AdvertisementConfiguration",
                                            "kind": "LinkedField",
                                            "name": "advertisementConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isFeatured",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "RootExtensionImpl",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "visibilityConfigs",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "configType",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v5/*: any*/),
                                        "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v5/*: any*/),
                                        "type": "NotAfterDateTimeVisibilityTreeConfig",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v5/*: any*/),
                                        "type": "AfterDateTimeVisibilityTreeConfig",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "firstReleasedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "tags",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "colorHex",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  }
                                ],
                                "type": "RootStructureDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasBeenPublishedOnce",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "typeDefinition",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "rewards",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "kind",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ContentTypeDefinition",
                                "abstractKey": "__isContentTypeDefinition"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v2/*: any*/),
                                      (v4/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ELearningContentTypeDefinition",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Versioning",
                            "kind": "LinkedField",
                            "name": "versioning",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "draftVersion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "releaseVersion",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "filterByIsRewardedByAny",
                  "filterByTagIds",
                  "filterByTitleOrDescriptionOrShortDescription",
                  "filterByVnr",
                  "filterByInternalVnr",
                  "filterByVisibility"
                ],
                "handle": "connection",
                "key": "RootNodesTable_GetRootNodes",
                "kind": "LinkedHandle",
                "name": "GetRootNodes"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bbfc7f442c673029c32b6499a2396d86",
    "id": null,
    "metadata": {},
    "name": "ProjectRootNodesTable_Refetch",
    "operationKind": "query",
    "text": "query ProjectRootNodesTable_Refetch(\n  $after: String\n  $filterByInternalVnr: String\n  $filterByIsRewardedByAny: Boolean\n  $filterByTagIds: [ID!]\n  $filterByTitleOrDescriptionOrShortDescription: String\n  $filterByVisibility: Boolean\n  $filterByVnr: String\n  $first: Int = 20\n) {\n  ...ProjectRootNodesTable_QueryFragment_2owISp\n}\n\nfragment ActionColumn_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n        }\n      }\n    }\n  }\n  ...ProjectExtendActionButtons_TreeNodeFragment\n}\n\nfragment ConfigurationBadgesColumn_TreeNodeFragment on TreeNode {\n  ...NodeConfigurationBadges_TreeNodeFragment\n  ...ProjectExtendNodeConfigurationBadges_TreeNodeFragment\n}\n\nfragment ContainerTag_TagFragment on Tag {\n  id\n  name\n  colorHex\n}\n\nfragment ContentColumn_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ELearningContentTypeDefinition {\n      elements {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment IsRewardedToColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          configConsequences {\n            isRewardedTo\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    definitionType\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n          configConsequences {\n            isRewardedTo\n          }\n          advertisementConfig {\n            isFeatured\n          }\n        }\n      }\n    }\n  }\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n  versioning {\n    draftVersion\n    releaseVersion\n  }\n}\n\nfragment PreviewPublishedNodeActionButton_TreeNodeFragment on TreeNode {\n  id\n  hasBeenPublishedOnce\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          displayType\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectExtendActionButtons_TreeNodeFragment on TreeNode {\n  ...PreviewPublishedNodeActionButton_TreeNodeFragment\n}\n\nfragment ProjectExtendNodeConfigurationBadges_TreeNodeFragment on TreeNode {\n  typeDefinition {\n    __typename\n    definitionType\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      rewards {\n        __typename\n        kind\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectRootNodesTable_QueryFragment_2owISp on Query {\n  Admin {\n    Tree {\n      GetRootNodes(first: $first, after: $after, filterByIsRewardedByAny: $filterByIsRewardedByAny, filterByTagIds: $filterByTagIds, filterByTitleOrDescriptionOrShortDescription: $filterByTitleOrDescriptionOrShortDescription, filterByVnr: $filterByVnr, filterByInternalVnr: $filterByInternalVnr, filterByVisibility: $filterByVisibility) {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            ...RootNodesTable_TreeNodeFragment\n            id\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n}\n\nfragment ReleasedAtColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      firstReleasedAt\n    }\n  }\n}\n\nfragment RootNodesTable_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      extension {\n        __typename\n        ... on RootExtensionImpl {\n          configConsequences {\n            rewardExpired\n          }\n        }\n      }\n      visibilityConfigs {\n        __typename\n        configType\n        ... on OnlySpecificPermissionsVisibilityTreeConfig {\n          id\n          configType\n          dateTime\n        }\n        ... on NotAfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        ... on AfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        id\n      }\n    }\n  }\n  ...ActionColumn_TreeNodeFragment\n  ...ConfigurationBadgesColumn_TreeNodeFragment\n  ...ContentColumn_TreeNodeFragment\n  ...IsRewardedToColumn_TreeNodeFragment\n  ...ReleasedAtColumn_TreeNodeFragment\n  ...TagsColumn_TreeNodeFragment\n  ...TitleColumn_TreeNodeFragment\n}\n\nfragment TagsColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      tags {\n        id\n        ...ContainerTag_TagFragment\n      }\n    }\n  }\n}\n\nfragment TitleColumn_TreeNodeFragment on TreeNode {\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      icon {\n        url\n        id\n      }\n      title\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "59965db4b79d7143e7cec645274606fd";

export default node;
